module.exports = __webpack_public_path__ + "static/media/login.e3519500.png";